var KEFU_CLICK_SELECTOR = '.kefu, #wx-kefu-btn, .article-kefu__btn, .kefu-btn, .float-kefu, .domain-card__consult-btn, .daetool-pay-checkout__kefu, .daetool-pay-success__kefu';
/** 打开七鱼在线客服（需 footer 已初始化 ysf） */
export function openKefu() {
    if (typeof ysf !== 'function') {
        console.warn('七鱼客服 SDK 未就绪');
        return;
    }
    var url = ysf('url');
    if (url) {
        window.open(url, '_blank');
    }
}
var globalBound = false;
/** PC 页统一：点击客服入口跳转七鱼（不含 footer .item-link-btn，由 footerMain 处理） */
export function bindGlobalKefuClick() {
    if (globalBound)
        return;
    globalBound = true;
    document.addEventListener('click', function (e) {
        var target = e.target.closest(KEFU_CLICK_SELECTOR);
        if (!target || target.closest('.item-link-btn'))
            return;
        e.preventDefault();
        openKefu();
    });
}
